module.exports = __webpack_public_path__ + "img/elo.c.88261805.png";